import React, { Component } from "react";
import { tableIcons } from "utils/MaterialTableHelper";
import colors from "styles/colors.module.scss";
import { uepClient } from "uepClient";
import WithAlert from "hoc/WithAlert";
import { getUsername } from "utils/Common";
import TableToolbar from "components/UserAdminContent/TableToolbar";
import AdminTableWrapper from "components/UserAdminContent/AdminTableWrapper";
import { Modal } from "react-bootstrap";
import dayjs from "utils/dayjs";
import AddBrochureForm from "./AddBrochureForm";
import BrochureSummaryService from "services/BrochureSummaryService";

const DATE_FORMAT = "DD MMM YYYY hh:mm a";
class UserAdminBrochures extends Component {
  constructor() {
    super();
    this.state = {
      isLoading: true,
      brochuresData: [],
      selectedRows: [],
      searchText: "",
      showAddBrochureForm: false,
      isEditMode: false,
    };
    this.currentUser = getUsername();
  }
  componentDidMount() {
    this.fetchAllBrochures();
  }
  render() {
    const {
      isLoading,
      showAddBrochureForm,
      isEditMode,
      selectedRows,
    } = this.state;
    return (
      <div className="admin-content">
        <div className="admin-list-table-container">
          <div className="table-wrapper">
            {this.renderTableToolbar()}
            <AdminTableWrapper
              icons={tableIcons}
              columns={this.getTableColumns()}
              data={this.getBrochuresData()}
              isLoading={isLoading}
              onSelectionChange={this.onRowSelection}
              emptyMessage="No brochures found."
              isRowSelected={this.isRowSelected}
            />
          </div>
        </div>
        <Modal
          className="add-brochure-modal"
          centered
          onHide={this.onAddBrochureFormClose}
          show={showAddBrochureForm}
        >
          <AddBrochureForm
            onAddBrochureFormClose={this.onAddBrochureFormClose}
            onNewBrochureAdded={this.addNewBrochureToTable}
            onBrochureEdited={this.updateEditedBrochureInTable}
            isEditMode={isEditMode}
            brochureToUpdate={selectedRows[0]}
          />
        </Modal>
      </div>
    );
  }
  isRowSelected = (row) => {
    const { selectedRows } = this.state;
    const selectedRowIndex = selectedRows.findIndex((r) => r.id === row.id);
    return selectedRowIndex > -1;
  };
  renderTableToolbar = () => {
    return (
      <TableToolbar
        searchValue={this.state.searchText}
        onSearchTextChange={this.onSearchTextChange}
        onAddButtonClick={this.onAddBrochureClick}
        isEditEnabled={this.state.selectedRows.length === 1}
        isDeleteEnabled={this.state.selectedRows.length > 0}
        onDeleteClick={this.onDeleteClick}
        onEditClick={this.onEditClick}
        title="Manage Brochures"
      />
    );
  };

  onDeleteClick = () => {
    const { selectedRows } = this.state;
    const selectedBrochureIds = selectedRows.map((r) => r.id);
    this.deleteBrochures(selectedBrochureIds);
  };

  deleteBrochures = (selectedBrochureIds) => {
    this.setState({
      isLoading: true,
    });
    const brochureIdsQueryParams = selectedBrochureIds.join(",");
    uepClient()
      .delete(`/file-info/delete?fileIds=${brochureIdsQueryParams}`)
      .then((res) => {
        if (res.status === 200) {
          this.removeDeletedBrochuresFromTable(selectedBrochureIds);
          console.info(
            `Admin ${this.currentUser} deleted brochures with file ids: ${selectedBrochureIds}`
          );
          this.props.showAlert({
            variant: "success",
            content: (
              <span>
                <b>Succesfully</b> deleted the selected brochures.
              </span>
            ),
          });
        }
      })
      .catch((err) => {
        const errorMessageToDisplay = `Error occurred while Admin-${
          this.currentUser
        } trying to delete brochures: ${selectedBrochureIds.join(",")}`;

        this.props.showAlert({
          variant: "danger",
          content: (
            <span>
              <b>Error!</b> {errorMessageToDisplay}
            </span>
          ),
        });
        console.error(
          `Error occurred while Admin-${
            this.currentUser
          } trying to delete brochures: ${selectedBrochureIds.join(
            ","
          )}, ${err}`
        );
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  notifyBrochureAdminSummary = () => {
    BrochureSummaryService.fetchBrochureSummaryData();
  };

  addNewBrochureToTable = (newBrochure) => {
    const { brochuresData } = this.state;

    const newBrochureToAdd = { ...newBrochure };

    const existingBrochures = [].concat(brochuresData);

    const updatedBrochures = existingBrochures.concat(newBrochureToAdd);
    this.setState({
      brochuresData: updatedBrochures,
      selectedRows: [],
    });

    this.notifyBrochureAdminSummary();
  };

  updateEditedBrochureInTable = (updatedBrochure) => {
    const { brochuresData } = this.state;
    const existingBrochures = [].concat(brochuresData);
    const indexOfExistingBrochureToUpdate = existingBrochures.findIndex(
      (b) => b.id === updatedBrochure.id
    );
    if (indexOfExistingBrochureToUpdate !== -1) {
      existingBrochures.splice(
        indexOfExistingBrochureToUpdate,
        1,
        updatedBrochure
      );
    }
    this.setState({
      brochuresData: existingBrochures,
      selectedRows: [],
    });

    this.notifyBrochureAdminSummary();
  };

  removeDeletedBrochuresFromTable = (deletedFileIds) => {
    const { brochuresData } = this.state;
    const updatedbrochuresData = brochuresData.filter(
      (u) => !deletedFileIds.includes(u.id)
    );
    this.setState({
      brochuresData: updatedbrochuresData,
      selectedRows: [],
    });

    this.notifyBrochureAdminSummary();
  };

  onEditClick = () => {
    this.setState({
      showAddBrochureForm: true,
      isEditMode: true,
    });
  };

  onAddBrochureClick = () => {
    this.setState({
      isEditMode: false,
      showAddBrochureForm: true,
    });
  };

  onAddBrochureFormClose = () => {
    this.setState({
      showAddBrochureForm: false,
    });
  };

  onSearchTextChange = (searchText) => {
    this.setState({
      searchText,
    });
  };

  fetchAllBrochures = () => {
    this.setState({ isLoading: true });
    uepClient()
      .get("/file-info")
      .then((res) => {
        this.setState({
          brochuresData: res.data,
          isLoading: false,
        });
      })
      .catch((err) => {
        console.error(`Failed to fetch list of brochures for admin : ${err}`);
        this.props.showAlert({
          variant: "danger",
          content: (
            <span>
              <b>Error!</b> Failed to fetch list of brochures for admin.
            </span>
          ),
        });
      });
  };
  getBrochuresData = () => {
    const { brochuresData, searchText } = this.state;
    return searchText.trim().length
      ? brochuresData.filter((r) => this.validateSearch(r))
      : brochuresData;
  };
  validateSearch = (row) => {
    const { searchText } = this.state;
    const searchLc = searchText.toLowerCase();
    const filenameValidator = row.name.toLowerCase().includes(searchLc);
    const fileTypeValidator = row.fileType.toLowerCase().includes(searchLc);
    const updatedAtValidator =
      dayjs(row.updatedAt)
        .format(DATE_FORMAT)
        .toString()
        .toLowerCase()
        .includes(searchLc) ||
      dayjs(row.createdAt)
        .format(DATE_FORMAT)
        .toString()
        .toLowerCase()
        .includes(searchLc);
    return (
      filenameValidator ||
      updatedAtValidator ||
      fileTypeValidator
    );
  };
  getTableColumns = () => {
    const tableColumns = [
      {
        title: "Filename",
        field: "name",
        filtering: false,
        sorting: false,
      },
      {
        title: "Group",
        field: "group",
        filtering: true,
        render: () => {
          return "SALES";
        },
      },
      {
        title: "Last Updated",
        field: "updatedAt",
        defaultSort: "desc",
        customSort: (a, b) => {
          const dateTimeA = a.updatedAt ? a.updatedAt : a.createdAt;
          const dateTimeB = b.updatedAt ? b.updatedAt : b.createdAt;
          return dayjs(dateTimeA).isAfter(dayjs(dateTimeB)) ? 1 : -1;
        },
        render: (rowData) => {
          return rowData.updatedAt
            ? dayjs(rowData.updatedAt).format(DATE_FORMAT)
            : dayjs(rowData.createdAt).format(DATE_FORMAT);
        },
      },
      {
        title: "FileType",
        field: "fileType",
        filtering: true,
        sorting: true,
      },
    ];

    const tableColumnsWithStyle = tableColumns.map((tc) => ({
      ...tc,
      cellStyle: {
        border: 0,
        color: colors.darkGrey,
        fontWeight: "normal",
      },
      headerStyle: {
        border: 0,
        color: colors.darkGrey,
        fontWeight: "300",
        fontSize: "1em",
      },
    }));
    return tableColumnsWithStyle;
  };

  onRowSelection = (rows) => {
    this.setState({
      selectedRows: rows,
    });
  };
}

const UserAdminBrochuresWithAlert = WithAlert(UserAdminBrochures);

export default UserAdminBrochuresWithAlert;
